export const PASSWORD_POLICY_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;

export const PASSWORD_POLICY_MESSAGE =
  'A senha deve ter no mínimo 8 caracteres, com letra maiúscula, letra minúscula, número e caractere especial.';

export const PASSWORD_POLICY_HINT =
  'Mínimo de 8 caracteres com ao menos 1 letra maiúscula, 1 letra minúscula, 1 número e 1 caractere especial.';